import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const CardOnePayIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 -20 100 69"
        ref={ref}
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g fill="none" fillRule="evenodd">
          <g fill="#231F20">
            <path d="M49.4 8.8C49.4 4 45.5 0 40.7 0c-4.9 0-8.8 4.1-8.8 9.1s3.9 8.9 8.9 8.9c3.6 0 7-2.5 8.1-5.9h-4.4c-.9 1.5-2.1 2.2-3.8 2.2-2 0-3.9-1.5-4.5-3.5h13c.1-1 .2-1.4.2-2ZM36 7.6c.5-2.4 2.4-3.9 4.8-3.9 2.3 0 4.1 1.5 4.7 3.9H36Z" />
            <g fillRule="nonzero">
              <path d="M8.7.2c1.6 0 3.1.4 4.5 1.2 1.4.8 2.5 1.9 3.3 3.2.8 1.4 1.2 2.8 1.2 4.4 0 1.6-.4 3.1-1.2 4.5-.8 1.4-1.9 2.5-3.2 3.2-1.4.8-2.9 1.2-4.5 1.2-2.4 0-4.5-.9-6.2-2.6C.9 13.6 0 11.5 0 9c0-2.6 1-4.8 2.9-6.6C4.6.9 6.5.2 8.7.2Zm.1 3.9c-1.3 0-2.4.5-3.3 1.4-.8.9-1.3 2.1-1.3 3.5 0 1.5.4 2.7 1.3 3.6.9.9 2 1.4 3.3 1.4 1.3 0 2.4-.5 3.3-1.4.9-.9 1.3-2.1 1.3-3.5s-.4-2.6-1.3-3.5c-.8-1-1.9-1.5-3.3-1.5Z" />
              <path d="M17.3.6h4.2v1.7c1-.8 1.8-1.4 2.6-1.7.8-.3 1.6-.5 2.4-.5 1.7 0 3.1.6 4.3 1.8 1 1 1.5 2.5 1.5 4.4v11.1h-4.2V10c0-2-.1-3.3-.3-4-.2-.7-.5-1.2-.9-1.5-.4-.3-1-.5-1.7-.5-.9 0-1.6.3-2.2.9-.6.6-1 1.4-1.3 2.4-.1.5-.2 1.7-.2 3.4v6.8h-4.2V.6Z" />
            </g>
          </g>
          <g fill="#FAAC3E">
            <path d="M52.9 23.1v-7.2c1.7 1.6 3 2.2 5.2 2.2 4.7 0 8.5-4 8.5-9.1S62.9.1 58.2.1c-2.3 0-4.2.9-5.5 2.6v-2H49v22.5h3.9v-.1Zm4.7-19.4c2.7 0 4.9 2.4 4.9 5.3s-2.2 5.3-4.9 5.3S52.7 12 52.7 9c-.1-3 2.1-5.3 4.9-5.3Z" />
            <path d="M79.4.6v2.1C78.1 1.1 75.8 0 73.7 0c-4.8 0-8.4 3.8-8.4 8.9 0 5.2 3.5 9.1 8.2 9.1 2.1 0 4.7-1.1 5.9-2.6v2.1h3.7V.6h-3.7Zm-5.1 13.7c-2.8 0-5-2.3-5-5.2 0-3.1 2.2-5.4 5-5.4 2.9 0 5 2.2 5 5.2 0 3.2-2.1 5.4-5 5.4Z" />
            <path d="M90.3 23.1 100 .6h-4.6l-4.1 10.8L87.5.6h-4.6L89 15.8l-3.1 7.3z" />
          </g>
        </g>
      </svg>
    );
  }
);
export default CardOnePayIcon;
